import { AxiosError } from 'axios';
import { HttpError } from 'react-admin';
import { ErrorData } from 'types/embedded/error';

export function formatAxiosToHydraError(error: AxiosError<ErrorData>): HttpError {
  const data = error?.response?.data;

  return new HttpError(
    data?.['hydra:description'] || data?.detail || 'Неизвестная ошибка',
    error?.response?.status || 500,
    data,
  );
}
